import { Action, State } from "./type";

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_THEME":
      return { ...state, theme: action.payload.theme };
    case "INIT_STATE":
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
